import api from './api';

const formularioService = {
  // Obtener formulario por ID
  getFormulario: async (id) => {
    try {
      if (!id || id === 'undefined') {
      throw new Error('ID de formulario no válido');
    }

     
      
      const response = await api.get(`/formularios/${id}`);
      
      // Normalizar la respuesta para asegurar consistencia
      if (response.data && response.data.data) {
        return response.data.data;
      } else if (response.data) {
        return response.data;
      } else {
        throw new Error('Formato de respuesta inesperado');
      }
    } catch (error) {
      console.error(`Error al obtener formulario ${id}:`, error);
      throw error;
    }
  },
  
  // Obtener todos los formularios
  getFormularios: async () => {
    try {
      const response = await api.get('/formularios');
      
      // Normalizar la respuesta
      if (response.data && response.data.data) {
        return response.data.data;
      } else if (response.data) {
        return response.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error('Error al obtener formularios:', error);
      return [];
    }
  },
  
  // Crear nuevo formulario
  crearFormulario: async (data) => {
    try {
      const response = await api.post('/formularios', data);
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error al crear formulario:', error);
      throw error;
    }
  },
  
  // Actualizar formulario
  actualizarFormulario: async (id, data) => {
    try {
      const response = await api.put(`/formularios/${id}`, data);
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error al actualizar formulario:', error);
      throw error;
    }
  },
  
  // Eliminar formulario
  eliminarFormulario: async (id) => {
    try {
      const response = await api.delete(`/formularios/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar formulario:', error);
      throw error;
    }
  },
  
  // 🔧 MÉTODO CORREGIDO - Obtener respuestas por historia especialidad
  getRespuestasPorHistoriaEspecialidad: async (historiaEspecialidadId) => {
    try {
      // ✅ Validación y conversión del ID
      if (!historiaEspecialidadId) {
        console.warn('historiaEspecialidadId es null o undefined');
        return { data: [] };
      }

      // ✅ Asegurar que sea un número/string válido
      const id = typeof historiaEspecialidadId === 'object' 
        ? (historiaEspecialidadId.id || historiaEspecialidadId.historia_especialidad_id || historiaEspecialidadId)
        : historiaEspecialidadId;

      // ✅ Validar que tengamos un ID válido
      if (!id || id === 'undefined' || id === '[object Object]') {
        console.error('ID de historia especialidad no válido:', { historiaEspecialidadId, id });
        return { data: [] };
      }

      
      
      const response = await api.get(`/formularios/respuestas/historia-especialidad/${id}`);
      return response.data || response;
    } catch (error) {
      console.error('Error al obtener respuestas por historia especialidad:', error);
      return { data: [] }; // Devolver estructura segura
    }
  },

  // Obtener formularios por etapa
  getFormulariosPorEtapa: async (etapaId) => {
  try {
    const response = await api.get(`/formularios/etapa/${etapaId}`);
   
    // ✅ CORRECCIÓN REAL: response.data contiene la respuesta del backend
    if (response.data && response.data.success && response.data.data) {
      
      
      return {
        data: {
          formularios: response.data.data.formularios || [], // ✅ ACCESO CORRECTO
          etapa: response.data.data.etapa,
          tieneFormularios: response.data.data.tieneFormularios,
          mensaje: response.data.data.mensaje
        }
      };
    }
    
    // ✅ Fallback mejorado
     
    return {
      data: {
        formularios: Array.isArray(response.data) ? response.data : [],
        etapa: null,
        tieneFormularios: false,
        mensaje: null
      }
    };
  } catch (error) {
    console.error('❌ Error al obtener formularios por etapa:', error);
    return {
      data: {
        formularios: [],
        etapa: null,
        tieneFormularios: false,
        mensaje: 'Error al cargar formularios'
      }
    };
  }
},
  
  // Obtener formularios por especialidad
  getFormulariosPorEspecialidad: async (especialidadId) => {
    try {
       
      const response = await api.get(`/formularios/especialidad/${especialidadId}`);
      
      // Normalizar la respuesta
      if (response.data && response.data.data) {
        return response.data.data;
      } else if (response.data) {
        return response.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error('Error al obtener formularios por especialidad:', error);
      throw error;
    }
  },

  // Obtener respuestas por paciente
  getRespuestasPorPaciente: async (pacienteId, formularioId = null) => {
    try {
      const params = {};
      if (formularioId) params.formulario_id = formularioId;
      
      const response = await api.get(`/formulario-respuestas/paciente/${pacienteId}`, { params });
      return response.data.data || response.data || [];
    } catch (error) {
      console.error('Error al obtener respuestas:', error);
      throw error;
    }
  },
  
  // 🔧 MÉTODO CORREGIDO - Obtener respuestas por historia clínica
  getRespuestasPorHistoria: async (historiaIdOrParams) => {
    try {
       
      
      // ✅ Validar parámetro
      if (!historiaIdOrParams) {
        console.error('Parámetro vacío en getRespuestasPorHistoria');
        return { data: [] };
      }
      
      let url = '';
      let id = null;
      
      // ✅ Manejar diferentes tipos de entrada de forma más robusta
      if (typeof historiaIdOrParams === 'object' && historiaIdOrParams !== null) {
         
        
        // Extraer ID del objeto
        if (historiaIdOrParams.historia_especialidad_id) {
          id = historiaIdOrParams.historia_especialidad_id;
          url = `/formularios/respuestas/historia-especialidad/${id}`;
        } else if (historiaIdOrParams.historia_clinica_id) {
          id = historiaIdOrParams.historia_clinica_id;
          url = `/formularios/respuestas/historia/${id}`;
        } else if (historiaIdOrParams.id) {
          id = historiaIdOrParams.id;
          url = `/formularios/respuestas/historia/${id}`;
        } else {
          console.error('❌ Objeto sin propiedades válidas:', historiaIdOrParams);
          return { data: [] };
        }
      } else if (typeof historiaIdOrParams === 'string' || typeof historiaIdOrParams === 'number') {
        // ID simple
        id = historiaIdOrParams;
        url = `/formularios/respuestas/historia/${id}`;
      } else {
        console.error('❌ Tipo de parámetro no válido:', typeof historiaIdOrParams, historiaIdOrParams);
        return { data: [] };
      }
      
      // ✅ Validar que el ID sea válido
      if (!id || id === 'undefined' || id === '[object Object]') {
        console.error('❌ ID extraído no válido:', { original: historiaIdOrParams, id, url });
        return { data: [] };
      }
      
    
      const response = await api.get(url);
      return response.data || response;
    } catch (error) {
      console.error('❌ Error al obtener respuestas por historia:', error);
      return { data: [] }; // Devolver estructura segura
    }
  },

  // Obtener una respuesta específica
  getRespuesta: async (id) => {
    try {
      const response = await api.get(`/formularios/respuestas/${id}`);
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error al obtener respuesta:', error);
      throw error;
    }
  },
  
  // Guardar respuesta de formulario
  guardarRespuesta: async (data) => {
  try {
     
    // ✅ ASEGURAR DATOS MÍNIMOS REQUERIDOS
    if (!data.historia_especialidad_id || !data.formulario_id) {
      throw new Error('historia_especialidad_id y formulario_id son requeridos');
    }
    
    const response = await api.post('/formularios/respuestas', data);
    
    // Log para debug
    if (response.data.action) {
     }
    
    return response.data.data || response.data;
  } catch (error) {
    console.error('❌ SERVICE: Error al guardar respuesta:', error);
    
    // Si el error es por constraint único, mostrar mensaje más claro
    if (error.response?.data?.message?.includes('Duplicate')) {
      throw new Error('Ya existe una respuesta para este formulario. Los datos se actualizarán automáticamente.');
    }
    
    throw error;
  }
},
  
guardarOActualizarRespuesta: async (data, respuestaExistenteId = null) => {
  try {
    if (respuestaExistenteId) {
      // Actualizar respuesta existente
       return await formularioService.actualizarRespuesta(respuestaExistenteId, data);
    } else {
      // Crear nueva respuesta (con protección anti-duplicados en backend)
       return await formularioService.guardarRespuesta(data);
    }
  } catch (error) {
    console.error('❌ SERVICE: Error en guardarOActualizarRespuesta:', error);
    throw error;
  }
},

  // Actualizar respuesta
  actualizarRespuesta: async (respuestaId, datos) => {
    try {
      const response = await api.put(`/formularios/respuestas/${respuestaId}`, datos);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar respuesta:', error);
      throw error;
    }
  },
  
  // Eliminar respuesta
  eliminarRespuesta: async (id) => {
    try {
      const response = await api.delete(`/formularios/respuestas/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar respuesta:', error);
      throw error;
    }
  },
  
  // Obtener especialidades
  getEspecialidades: async () => {
    try {
      const response = await api.get('/especialidades');
      return response.data;
    } catch (error) {
      console.error('Error al obtener especialidades:', error);
      throw error;
    }
  },
  
  // Exportar respuestas a PDF
  exportarRespuestaAPDF: async (respuestaId) => {
    try {
      const response = await api.get(`/formularios/respuestas/${respuestaId}/pdf`, {
        responseType: 'blob'
      });
      
      // Crear URL para descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `formulario_respuesta_${respuestaId}.pdf`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      link.remove();
      
      return true;
    } catch (error) {
      console.error('Error al exportar a PDF:', error);
      throw error;
    }
  },
  
  // Obtener programas por especialidad
  getProgramasByEspecialidad: async (especialidadId) => {
    try {
      const response = await api.get(`/programas/especialidad/${especialidadId}`);
      return response.data.data || response.data || [];
    } catch (error) {
      console.error('Error obteniendo programas por especialidad:', error);
      return [];
    }
  },
    
  // Obtener etapas por programa
  getEtapasByPrograma: async (programaId) => {
    try {
      const response = await api.get(`/etapas-tratamiento/programa/${programaId}`);
      return response.data.data || response.data || [];
    } catch (error) {
      console.error('Error obteniendo etapas por programa:', error);
      return [];
    }
  },
  
  // Obtener etapas por especialidad
  getEtapasByEspecialidad: async (especialidadId) => {
    try {
      const response = await api.get(`/etapas-tratamiento/especialidad/${especialidadId}`);
      return response.data.data || response.data || [];
    } catch (error) {
      console.error('Error obteniendo etapas por especialidad:', error);
      return [];
    }
  },
  
  // Obtener todos los programas
  getProgramas: async () => {
    try {
      const response = await api.get('/programas');
      return response.data.data || response.data || [];
    } catch (error) {
      console.error('Error obteniendo programas:', error);
      return [];
    }
  },
  
  // Crear plantilla
  createPlantilla: async (data) => {
    try {
      const response = await api.post('/plantillas', data);
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error al crear plantilla:', error);
      throw error;
    }
  },
  
  // Actualizar plantilla
  updatePlantilla: async (id, data) => {
    try {
      const response = await api.put(`/plantillas/${id}`, data);
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error al actualizar plantilla:', error);
      throw error;
    }
  },
  
  // Asignar especialidades a un formulario
  asignarEspecialidades: async (formularioId, especialidadesIds) => {
    try {
      const response = await api.post(`/formularios/${formularioId}/especialidades`, {
        especialidades: especialidadesIds
      });
      return response.data;
    } catch (error) {
      console.error('Error al asignar especialidades al formulario:', error);
      throw error;
    }
  },
  
  // Verificar si el paciente puede avanzar a la siguiente etapa
  verificarFormulariosCompletados: async (pacienteId, etapaId) => {
    try {
      const response = await api.get(`/formularios/verificar-completados/${pacienteId}/${etapaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al verificar formularios completados:', error);
      return { puedeAvanzar: false, pendientes: [] };
    }
  },
 
  /**
  * Sube una plantilla PDF para un formulario
  */
  subirPlantillaPDF: async (formularioId, formData) => {
    try {
      const response = await api.post(`/formularios/${formularioId}/plantilla`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error subiendo plantilla PDF:', error);
      throw error;
    }
  },

  /**
  * Obtiene los campos de la plantilla PDF de un formulario
  */
  getPlantillaFields: async (formularioId) => {
    try {
      const response = await api.get(`/formularios/${formularioId}/plantilla/campos`);
      let campos = [];
    if (response.data) {
      if (response.data.data && Array.isArray(response.data.data)) {
        campos = response.data.data;
      } else if (response.data.campos && Array.isArray(response.data.campos)) {
        campos = response.data.campos;
      } else if (Array.isArray(response.data)) {
        campos = response.data;
      }
    }
    return campos;
      //return response.data.data || response.data || [];
    } catch (error) {
      console.error('Error obteniendo campos de la plantilla:', error);
      throw error;
    }
  },

  /**
  * Guarda el mapeo de campos para un formulario
  */
  guardarMapeoCampos: async (formularioId, mapeo) => {
    try {
      const response = await api.post(`/formularios/${formularioId}/mapeo`, mapeo);
      return response.data;
    } catch (error) {
      console.error('Error guardando mapeo de campos:', error);
      throw error;
    }
  },

  /**
  * Genera un PDF rellenado con los datos de una respuesta
  */
  generarPDF: async (formularioId, respuestaId) => {
    try {
      const response = await api.get(`/formularios/${formularioId}/respuesta/${respuestaId}/pdf`);
      return response.data;
    } catch (error) {
      console.error('Error generando PDF:', error);
      throw error;
    }
  },
  cerrarFormulario: async (respuestaId, motivo = '') => {
  try {
    const response = await api.post(`/formularios/respuestas/${respuestaId}/cerrar`, { motivo });
    return response.data;
  } catch (error) {
    console.error('Error al cerrar formulario:', error);
    throw error;
  }
},

reabrirFormulario: async (respuestaId, motivo = '') => {
  try {
 
    const response = await api.post(`/formularios/respuestas/${respuestaId}/reabrir`, { motivo });
    
     return response.data;
  } catch (error) {
    console.error('🔧 SERVICE: ERROR completo:', error);
    console.error('🔧 SERVICE: Error request:', error.request);
    console.error('🔧 SERVICE: Error response:', error.response);
    console.error('🔧 SERVICE: Error config:', error.config);
    throw error;
  }
},

getEstadoFormulario: async (respuestaId) => {
  try {
    const response = await api.get(`/formularios/respuestas/${respuestaId}/estado`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener estado del formulario:', error);
    throw error;
  }
},

/**
 * Obtener formularios hijos disponibles para un formulario padre
 */
getFormulariosHijos: async (parentRespuestaId) => {
  try {
    const response = await api.get(`/formularios/respuestas/${parentRespuestaId}/hijos`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener formularios hijos:', error);
    throw error;
  }
},

/**
 * Guardar respuesta de formulario hijo
 */
guardarRespuestaHijo: async (data) => {
  try {
    const response = await api.post('/formularios/respuestas/hijo', data);
    return response.data;
  } catch (error) {
    console.error('Error al guardar respuesta hijo:', error);
    throw error;
  }
},

/**
 * Obtener análisis de progreso
 */
getAnalisisProgreso: async (parentRespuestaId) => {
  try {
    const response = await api.get(`/formularios/respuestas/${parentRespuestaId}/analisis`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener análisis de progreso:', error);
    throw error;
  }
},

/**
 * Verificar si un formulario puede tener hijos
 */
puedeTenerHijos: async (respuestaId) => {
  try {
    const response = await api.get(`/formularios/respuestas/${respuestaId}/puede-tener-hijos`);
    return response.data;
  } catch (error) {
    console.error('Error al verificar si puede tener hijos:', error);
    return { success: false, data: { puede_tener_hijos: false } };
  }
},

/**
 * Obtener objetivos disponibles del formulario padre
 */
getObjetivosDisponibles: async (respuestaId) => {
  try {
    const response = await api.get(`/formularios/respuestas/${respuestaId}/objetivos-disponibles`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener objetivos disponibles:', error);
    return { success: false, data: { objetivos_disponibles: [] } };
  }
},

/**
 * Reabrir formulario padre (solo admin)
 */
reabrirFormularioPadre: async (respuestaId, motivo = '') => {
  try {
    const response = await api.post(`/formularios/respuestas/${respuestaId}/reabrir-padre`, { motivo });
    return response.data;
  } catch (error) {
    console.error('Error al reabrir formulario padre:', error);
    throw error;
  }
},

/**
 * Obtener historial de cambios de estado
 */
getHistorialCambios: async (respuestaId) => {
  try {
    const response = await api.get(`/formularios/respuestas/${respuestaId}/historial-cambios`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener historial de cambios:', error);
    return { success: false, data: [] };
  }
},

/**
 * Buscar formularios padre cerrados para una historia
 */
buscarFormulariosPadre: async (historiaEspecialidadId, especialidadId) => {
  try {
    const respuestas = await formularioService.getRespuestasPorHistoriaEspecialidad(historiaEspecialidadId);
    
    if (!respuestas.data || !Array.isArray(respuestas.data)) {
      return [];
    }
    
    // Filtrar solo formularios padre cerrados
    return respuestas.data.filter(r => 
      r.formulario &&
      r.formulario.tipo_dependencia === 'padre' &&
      r.estado === 'cerrado' &&
      (!especialidadId || r.formulario.especialidad_id === especialidadId)
    );
  } catch (error) {
    console.error('Error al buscar formularios padre:', error);
    return [];
  }
},

/**
 * Obtener formularios hijos de una respuesta padre
 */
getFormulariosHijosDeRespuesta: async (parentRespuestaId) => {
  try {
    const respuestas = await api.get(`/formularios/respuestas/historia`, {
      params: { parent_respuesta_id: parentRespuestaId }
    });
    return respuestas.data;
  } catch (error) {
    console.error('Error al obtener formularios hijos:', error);
    return { data: [] };
  }
},

/**
 * Validar si se puede crear un formulario hijo
 */
validarCreacionHijo: async (formularioHijoId, parentRespuestaId) => {
  try {
    const response = await api.post('/formularios/validar-dependencia', {
      formulario_hijo_id: formularioHijoId,
      parent_respuesta_id: parentRespuestaId
    });
    return response.data;
  } catch (error) {
    console.error('Error al validar creación de hijo:', error);
    return { 
      success: false, 
      message: error.response?.data?.message || 'Error al validar'
    };
  }
},

getRespuestasHijo: async (parentRespuestaId) => {
  try {
    const response = await api.get('/formularios/respuestas', {
      params: { parent_respuesta_id: parentRespuestaId }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener respuestas hijo:', error);
    throw error;
  }
},
// Obtener objetivos disponibles del formulario padre con historial
async getObjetivosDisponibles(parentRespuestaId) {
  try {
    const response = await api.get(`/formularios/respuestas/${parentRespuestaId}/objetivos-disponibles`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener objetivos disponibles:', error);
    throw error;
  }
},

// Guardar análisis funcional para un objetivo bloqueado
async guardarAnalisisFuncional(respuestaId, objetivoId, analisis) {
  try {
    const response = await api.post(`/formularios/respuestas/${respuestaId}/analisis-funcional`, {
      objetivo_id: objetivoId,
      analisis: analisis,
      fecha: new Date().toISOString()
    });
    return response.data;
  } catch (error) {
    console.error('Error al guardar análisis funcional:', error);
    throw error;
  }
},

// Obtener historial de un objetivo específico
async getHistorialObjetivo(parentRespuestaId, objetivoId) {
  try {
    const response = await api.get(`/formularios/objetivos/${objetivoId}/historial`, {
      params: { parent_respuesta_id: parentRespuestaId }
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener historial del objetivo:', error);
    throw error;
  }
},

// Verificar estado de bloqueo de objetivos
async verificarBloqueoObjetivos(respuestaId) {
  try {
    const response = await api.get(`/formularios/respuestas/${respuestaId}/verificar-bloqueos`);
    return response.data;
  } catch (error) {
    console.error('Error al verificar bloqueos:', error);
    throw error;
  }
},

buscarPlanGeneralReciente: async (historiaEspecialidadId, especialidadId = null) => {
  try {
    const params = {
      historiaEspecialidadId
    };
    
    if (especialidadId) {
      params.especialidadId = especialidadId;
    }
    
    const response = await api.get(`/formularios/respuestas/buscar-padre-reciente`, { params });
    return response.data;
  } catch (error) {
    console.error('Error al buscar plan general reciente:', error);
    throw error;
  }
},

/**
 * Obtener actividades disponibles del formulario padre
 */
getActividadesDisponibles: async (respuestaId) => {
  try {
    const response = await api.get(`/formularios/respuestas/${respuestaId}/actividades-disponibles`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener actividades disponibles:', error);
    return { success: false, data: { actividades_disponibles: [] } };
  }
},

/**
 * Obtener actividades por objetivo específico
 */
getActividadesPorObjetivo: async (objetivoId) => {
  try {
    const response = await api.get(`/formularios/objetivos/${objetivoId}/actividades`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener actividades por objetivo:', error);
    return { success: false, data: { actividades: [] } };
  }
},

};


export default formularioService;    